module.exports = __webpack_public_path__ + "img/star.09ffe1ad.svg";